module.exports = __webpack_public_path__ + "img/logo／h_w@2x.e7b14194.png";